import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { TriggersTable } from "../components"

export const TriggersPage: FC = () => (
  <UserbotPage title="Реактивные триггеры">
    <TriggersTable />
  </UserbotPage>
)
